export default {
  'searchVisitor':	'请输入关键字搜索客商',
  'searchProduct': '请输入关键字搜索展品',
  'searchActor': '请输入关键字搜索展商',
  'myWorker': '我的工作台',
  'myIsActor': '我是展商',
  'myIsVisitor': '我是客商',
  'common': '共',
  'condition': '条',
  'cancel': '取消',
  'sure': '确定',
  'wantToSee': '猜您想看',
  'businessCircle': '商脉圈',
  'collectionS': '收藏成功',
  'collectionF': '取消收藏',
  'inviteSuccess': '邀约成功',
  'invited': '已邀约',
  'employeeeManage': "员工管理",
  'preferredExhibits': '热门',
  'enterDetail': '进入详情',
  'contcatUs': '联系我们',
  'hotProduct': '热卖产品',
  'currentUser': '当前身份',
  'exhibitorInfo': '展商介绍',
  'productList': "产品中心",
  'uploadVideoImg': "上传视频封面",
  'companybaseMessManageEidt': '基本信息编辑',
  'personDetail': '客商详情',
  'actorDetail': '展商详情',
  'productDetail': '展品详情',
  'person': '找客商',
  'product': '找展品',
  'actor': '找展商',
  'popularity': '人气',
  'attention': '关注度',
  'video': '视频',
  'spell': '按名称A-Z',
  'changePass': '修改个人密码',
  'searchList': '搜索列表',
  'Booth': '展位号',
  'loginTip':'请先登录',
  'tip':'提示'
}
